export default __webpack_public_path__ + "static/47aa-b5ae6f1b48ba2eac593f77d5b9f2706e.png";